<template>

        <div class="lg:flex justify-end items-center leading-3 xl:px-10 px-5 mt-2.5  w-full">
            <slot></slot>
        </div>

</template>
<style>
.select-menu-height {height: 100%};
.border-color {color: #cacaca};
</style>
